module.exports = __webpack_public_path__ + "static/media/single.88e1ee59.mp3";